import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { FormattedMessage } from 'react-intl'
import { isNil } from 'lodash'

const PageSectionRow = ({ labelId, value, emptyId }) => {
  const isEmpty = isNil(value) || value === ''

  if (isEmpty && !emptyId) {
    return null
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption" color="text.secondary">
        <FormattedMessage id={labelId} />
      </Typography>
      <Typography variant="body2">
        {isEmpty ? <FormattedMessage id={emptyId} /> : value}
      </Typography>
    </Box>
  )
}

export default PageSectionRow
